import styled from 'styled-components';
import { IonButtons } from '@ionic/react';

export const PageHeaderEndSlot = styled(IonButtons)`
  column-gap: 20px;
  align-items: center;

  & .balance-wrapper {
    display: flex;
    flex-direction: column;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: #1d201f;
    row-gap: 4px;

    & b {
      font-weight: 600;
    }

    & .subscription-period {
      font-size: 10px;
      line-height: 14px;

      & b {
        font-size: 12px;
      }
    }
  }

  & .information-icon-wrapper {
    outline: none;
    border: none;
    padding: 0;
    margin: 0 -3px 0 0;
    width: 27px;
    height: 27px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;

    & ion-icon {
      font-size: 27px;
      color: #000;
    }

    &:active {
      background: transparent;
    }
  }
`;

export const PageHeaderStartSlot = styled(IonButtons)`
  & .back-chevron {
    outline: none;
    background: transparent;
    border: none;
    margin: 0 0 0 -7px;
    padding: 0;
    font-size: 24px;
    width: 24px;
    height: 24px;
    color: #000000;
  }
`;

export const PageHeaderTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  & .header-title {
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    color: #1d201f;

    &.big-title {
      font-size: 20px;
      line-height: 24px;
    }
  }

  & .header-subtitle {
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    color: #1d201f;
  }
`;
